import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0db91d80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-12 items-stretch" }
const _hoisted_2 = { class: "flex items-center justify-between mt-0" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Team Settings ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-charcoal-ghost mention" }, "Team Members:", -1))
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-charcoal-ghost mention" }, "Pending Invites:", -1))
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "italic flex-grow ellipsis py-mention" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "settings-input flex"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Invite Collaborator ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Icon, {
        icon: ['fal', 'times'],
        class: "icon-base p-mention clickable",
        onClick: _ctx.closeHelper
      }, null, 8, ["onClick"])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (member) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "settings-link justify-between",
          key: member.id,
          style: { 'box-shadow': '0 0 #26262600' }
        }, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(member.name), 1),
          _createElementVNode("div", {
            class: "settings-btn italic",
            onClick: ($event: any) => (_ctx.copyEmail(member.email))
          }, _toDisplayString(member.email), 9, _hoisted_7)
        ]))
      }), 128))
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invites, (invite) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "settings-link items0center",
          key: invite.id,
          style: { 'box-shadow': '0 0 #26262600' }
        }, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(invite.email), 1),
          _createElementVNode("div", {
            class: "settings-btn",
            onClick: ($event: any) => (_ctx.copyInvite(invite.id))
          }, [
            _createVNode(_component_Icon, {
              icon: ['fal', 'copy'],
              class: "icon-sm m-sub"
            })
          ], 8, _hoisted_11),
          _createElementVNode("div", {
            class: "settings-btn",
            onClick: ($event: any) => (_ctx.revokeInvite(invite.id))
          }, _toDisplayString(invite.role == _ctx.Role.Revoked
              ? "revoking..."
              : invite.role == _ctx.Role.Error
              ? "revoke failed"
              : "revoke"), 9, _hoisted_12)
        ]))
      }), 128)),
      (_ctx.addInvite)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              ref: "invite",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.invite) = $event)),
              class: "flex-1",
              onKeydown: [
                _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendInvite && _ctx.sendInvite(...args)), ["enter"])),
                _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeInvite && _ctx.closeInvite(...args)), ["esc"]))
              ],
              placeholder: "collaborator's email"
            }, null, 544), [
              [_vModelText, _ctx.invite]
            ]),
            _createVNode(_component_Icon, {
              icon: ['fal', 'check-square'],
              class: _normalizeClass(["icon-base", { 'text-charcoal-ghost': !_ctx.validEmail, clickable: _ctx.validEmail }]),
              onClick: _ctx.sendInvite
            }, null, 8, ["class", "onClick"])
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "settings-input text-charcoal-ghost flex gap-mention",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openInvite && _ctx.openInvite(...args)))
          }, [
            _createVNode(_component_Icon, {
              icon: ['fal', 'plus-square'],
              class: "icon-base"
            }),
            _hoisted_14
          ]))
    ])
  ]))
}